
import { Users, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { EmployeeInfoProps } from './types';

export const EmployeeInfo = ({ provider }: EmployeeInfoProps) => {
  const getEmployeeCountDisplay = () => {
    if (provider.min_employee_count && provider.max_employee_count) {
      return `${provider.min_employee_count}-${provider.max_employee_count} employees`;
    } else if (provider.min_employee_count) {
      return `${provider.min_employee_count}+ employees`;
    } else if (provider.max_employee_count) {
      return `Up to ${provider.max_employee_count} employees`;
    }
    return null;
  };
  
  const employeeCountDisplay = getEmployeeCountDisplay();
  
  return (
    <div className="flex flex-col gap-1 text-sm text-gray-600">
      {employeeCountDisplay && (
        <div className="flex items-center mt-1">
          <Users className="h-4 w-4 mr-1" />
          <span>{employeeCountDisplay}</span>
        </div>
      )}
      
      {provider.payroll_platform && (
        <div className="flex items-center">
          <span className="text-xs bg-gray-100 px-2 py-0.5 rounded">
            Payroll: {provider.payroll_platform}
          </span>
        </div>
      )}
      
      {provider.renewal_date && (
        <div className="flex items-center">
          <Calendar className="h-4 w-4 mr-1" />
          <span>Renewal: {format(new Date(provider.renewal_date), 'MMM d, yyyy')}</span>
        </div>
      )}
    </div>
  );
};
